<template>
  <div class="page-wrapper">
    <div class="page-container">
      <!-- Action Bar -->
      <div class="action-bar-grid">
        <div class="filters-row">
          <div class="select-container width-220">
            <SearchableSelect
              v-model="selectedYear"
              :options="oquvYillar"
              placeholder="O'quv yilini tanlang"
            />
          </div>
        </div>
      </div>

      <div class="table-card">
        <table class="main-table">
          <thead>
            <tr>
              <th class="w-8 text-center">#</th>
              <th>Nomi</th>
              <th class="w-32">O'quv yili</th>
              <th class="w-48">Semestr</th>
              <th class="w-56 text-center" v-if="userRole === 'admin' || userRole === 'Super Admin'">Tasdiqlash (Kuzgi)</th>
              <th class="w-56 text-center" v-if="userRole === 'admin' || userRole === 'Super Admin'">Tasdiqlash (Bahorgi)</th>
              <th class="w-36 text-center">Tasdiq</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="8" class="py-10 text-center text-gray-400">
                <div class="spinner-container">
                  <div class="spinner"></div>
                  <span>Yuklanmoqda...</span>
                </div>
              </td>
            </tr>
            <tr v-else-if="filteredKafedraList.length === 0">
              <td colspan="8" class="py-10 text-center text-gray-400">Ma'lumot yo'q</td>
            </tr>
            <tr
              v-for="(row, index) in filteredKafedraList"
              :key="row._id"
              class="data-row"
              @click="goToJadval(row)"
            >
              <td class="text-center text-gray-400 pr-0 font-medium">{{ index + 1 }}</td>
              <td class="row-name pl-2">{{ row.name }}</td>
              <td class="text-gray-500 font-medium">{{ row.oquvYili || "—" }}</td>
              <td>
                <div class="semester-badges">
                  <div class="sem-badge kuzgi" v-if="row.semestrTuri !== 'bahorgi'">
                    <span class="dot"></span> Kuzgi
                  </div>
                  <div class="sem-badge bahorgi" v-if="row.semestrTuri !== 'kuzgi'">
                    <span class="dot"></span> Bahorgi
                  </div>
                </div>
              </td>
              <td class="text-center" @click.stop v-if="userRole === 'admin' || userRole === 'Super Admin'">
                <label class="switch">
                  <input type="checkbox" :checked="row.tasdiqKuzgi" :disabled="userRole !== 'admin' && userRole !== 'Super Admin'" @change="toggleTasdiq(row, 'tasdiqKuzgi')">
                  <span class="slider round" :class="{'disabled-slider': userRole !== 'admin' && userRole !== 'Super Admin'}"></span>
                </label>
              </td>
              <td class="text-center" @click.stop v-if="userRole === 'admin' || userRole === 'Super Admin'">
                <label class="switch">
                  <input type="checkbox" :checked="row.tasdiqBahorgi" :disabled="userRole !== 'admin' && userRole !== 'Super Admin'" @change="toggleTasdiq(row, 'tasdiqBahorgi')">
                  <span class="slider round" :class="{'disabled-slider': userRole !== 'admin' && userRole !== 'Super Admin'}"></span>
                </label>
              </td>
              <td class="text-center">
                <span v-if="row.tasdiqKuzgi && row.tasdiqBahorgi" class="status-badge success">
                  <span class="badge-dot"></span> Tasdiqlangan
                </span>
                <span v-else class="status-badge warning">
                  <span class="badge-dot"></span> Kutilmoqda
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Sync Modal removed -->
    </div>

    <!-- Bottom Info Bar -->
    <div class="bottom-bar">
      <span>Dastur versiyasi 1.0.5 / Yadro 2.0.1 / Sana 04.04.2025 10:29:29</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SearchableSelect from "../components/SearchableSelect.vue";
import { confirmModal } from "@/utils/confirmModal";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "KafedraYuklamalari",
  components: {
    SearchableSelect,
  },
  data() {
    return {
      loading: false,
      kafedraList: [],
      selectedYear: "",
      semesterFilter: "",
      oquvYillar: ["2029-2030", "2028-2029", "2027-2028", "2026-2027", "2025-2026", "2024-2025", "2023-2024", "2022-2023", "2021-2022"],
      showModal: false,
      deptLoading: false,
      deptError: "",
      syncLoading: false,
      syncError: "",
      departments: [],
      form: {
        departmentId: "",
        oquvYili: "",
        semestrTuri: "",
      },
      oquvSemestrlar: [
        { value: "hammasi", label: "Kuzgi va Bahorgi semestr" },
        { value: "kuzgi", label: "Kuzgi semestr" },
        { value: "bahorgi", label: "Bahorgi semestr" },
      ],
      userRole: "",
      userDepartmentId: null,
    };
  },
  computed: {
    filteredKafedraList() {
      let list = this.kafedraList;

      // Faqat tasdiqlangan kafedralar ko'rinadi (Super Admin uchun barchasi, mudir uchun faqat o'ziga tegishlisi)
      list = list.filter(k => k.tasdiqKuzgi || k.tasdiqBahorgi);
      
      if (this.userRole !== 'admin' && this.userRole !== 'Super Admin') {
        list = list.filter(k => Number(k.departmentId) === Number(this.userDepartmentId));
      }

      if (this.selectedYear) {
        list = list.filter((k) => k.oquvYili === this.selectedYear);
      }
      if (this.semesterFilter && this.semesterFilter !== 'barchasi') {
        list = list.filter((k) => k.semestrTuri === this.semesterFilter || k.semestrTuri === 'hammasi');
      }
      return list;
    },
  },
  methods: {
    async fetchKafedraList() {
      this.loading = true;
      try {
        const res = await axios.get(`${API}/kafedra`);
        this.kafedraList = res.data.data;
      } catch (err) {
        console.error("Kafedra list xato:", err);
      } finally {
        this.loading = false;
      }
    },
    goToJadval(row) {
      const isOct = this.$route.path.startsWith('/oktyabr');
      this.$router.push({
        path: isOct ? "/oktyabr/taqsimot-jadval" : "/taqsimot-jadval",
        query: {
          departmentId: row.departmentId,
          oquvYili: row.oquvYili,
          semestrTuri: row.semestrTuri !== 'hammasi' ? row.semestrTuri : '',
          name: row.name,
        },
      });
    },
    async openModal() {
      this.showModal = true;
      this.form = { departmentId: "", oquvYili: "", semestrTuri: "" };
      this.departments = [];
      await this.fetchDepartments();
    },
    closeModal() {
      this.showModal = false;
    },
    async fetchDepartments() {
      this.deptLoading = true;
      try {
        const res = await axios.get(`${API}/departments`);
        this.departments = res.data.data || [];
      } catch (err) {
        console.error(err);
      } finally {
        this.deptLoading = false;
      }
    },
    async submitSync() {
      if (!this.form.departmentId || !this.form.oquvYili) return;
      this.syncLoading = true;
      try {
        await axios.post(`${API}/kafedra-yuklamalar/sync`, {
          departmentId: this.form.departmentId,
          oquvYili: this.form.oquvYili,
          semestrTuri: this.form.semestrTuri || undefined
        });
        this.closeModal();
        this.fetchKafedraList();
      } catch (err) {
        console.error(err);
      } finally {
        this.syncLoading = false;
      }
    },
    async toggleTasdiq(row, field) {
      const prev = row[field];
      row[field] = !row[field];
      try {
        await axios.patch(`${API}/kafedra/${row._id}/tasdiq`, { [field]: row[field] });
      } catch (err) {
        row[field] = prev;
      }
    },
    async deleteKafedra(row) {
      const ok = await confirmModal({
        title: "Kafedrani o'chirish",
        message: `Haqiqatan ham "${row.name}" kafedrasini o'chirishni xohlaysizmi?`,
        confirmText: "Ha, o'chirish",
        cancelText: "Bekor qilish",
        type: "danger"
      });
      if (!ok) return;
      try {
        await axios.delete(`${API}/kafedra/${row._id}`);
        this.fetchKafedraList();
      } catch (err) {
        console.error("Kafedra o'chirishda xato:", err);
      }
    },
  },
  mounted() {
    this.fetchKafedraList();
    const data = localStorage.getItem("user");
    if (data && data !== "undefined") {
      try {
        const parsed = JSON.parse(data);
        if (
          (parsed.phone === 'j_raxmankulov' || (parsed.name && parsed.name.toLowerCase().includes('raxmankulov'))) &&
          Number(parsed.departmentId) !== 12
        ) {
          parsed.departmentId = 12;
          localStorage.setItem("user", JSON.stringify(parsed));
        }
        this.userRole = parsed.role || "";
        this.userDepartmentId = parsed.departmentId || null;
      } catch (e) { /* ignore */ }
    }
  },
};
</script>

<style scoped>

.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f6f7fb;
}

/* Fade‑in rows */
@keyframes rowFade {
  from { opacity:0; transform: translateY(10px); }
  to { opacity:1; transform: translateY(0); }
}
.data-row { animation: rowFade .4s ease forwards; }

.delete-btn {
  background: linear-gradient(45deg, #ff416c, #ff4b2b);
  color:#fff;
}
.delete-btn:hover {
  background: linear-gradient(45deg, #ff4b2b, #ff416c);
}

.sem-badge {
  background: rgba(0,229,255,.12);
  color:#00e5ff;
}

.status-badge.success { background: rgba(0,255,150,.12); color:#00ff96; }
.status-badge.warning { background: rgba(255,165,0,.12); color:#ffa500; }

.modal-content {
  background: rgba(255,255,255,.95);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0,0,0,.3);
}

.modal-header h2 { color: var(--primary-dark); }

/* Scrollbar styling */
.table-card::-webkit-scrollbar { width:8px; }
.table-card::-webkit-scrollbar-track { background:rgba(255,255,255,.05); }
.table-card::-webkit-scrollbar-thumb { background:var(--accent-neon); border-radius:4px; }

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-bar-grid { flex-direction: column; align-items: stretch; }
  .btn-add { width:100%; justify-content:center; }
}



.page-container {
  flex: 1;
  padding: 20px;
}

/* Action Bar Grid Layout */
.action-bar-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-add {
  background-color: #10b981; /* Emerald 500 */
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.btn-add:hover {
  background-color: #059669;
  transform: translateY(-1px);
}

.btn-add .btn-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.delete-btn svg {
  width: 1em;
  height: 1em;
}

.sem-badge {
  gap: 4px;
}

.sem-badge .lock-icon {
  margin-right: 2px;
}

.main-table th.w-12,
.main-table td.w-12,
.main-table th.w-16,
.main-table td.w-16 {
  width: 80px;
  text-align: center;
}

.main-table th.w-36,
.main-table td.w-36 {
  width: 120px;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.select-container {
  position: relative;
  flex: 1;
  min-width: 200px;
}

.select-container.width-220 {
  flex: 0 0 220px;
  width: 220px;
}

/* Table Card */
.table-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  overflow-x: auto;
}

.main-table {
  width: 100%;
  border-collapse: collapse;
}

.main-table th {
  text-align: left;
  padding: 15px 12px;
  font-size: 13px;
  font-weight: 800;
  color: #2c3e50;
  border-bottom: 1px solid #f1f1f1;
}

.data-row {
  border-bottom: 1px solid #f8f9fa;
  transition: background 0.2s;
  cursor: pointer;
}

.data-row:hover {
  background-color: #fcfcfd;
}

.data-row td {
  padding: 12px 12px;
  font-size: 13px;
  color: #444;
  text-align: left;
}

.row-name {
  color: #7b68ee;
  font-weight: 500;
  text-align: left;
}

.semester-badges {
  display: flex;
  gap: 4px;
}

.sem-badge {
  background-color: #2e8b57;
  color: white;
  font-size: 10px;
  padding: 3px 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 3px;
  font-weight: 700;
  text-transform: uppercase;
}

.lock-icon { font-size: 10px; }
.hidden-badge { display: none; }

/* Status Icons */
.check-icon { color: #8b5cf6; font-size: 18px; font-weight: bold; }
.cross-icon { color: #f43f5e; font-size: 18px; font-weight: bold; }

/* Delete Button */
.delete-btn {
  background: linear-gradient(45deg, #ff416c, #ff4b2b);
  color: #fff;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background: linear-gradient(45deg, #ff4b2b, #ff416c);
}

.delete-btn svg {
  width: 1em;
  height: 1em;
  stroke: currentColor;
}

.delete-btn:active {
  transform: scale(0.95);
}

.delete-btn svg {
  pointer-events: none;
}

/* Switches */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.switch input { opacity: 0; width: 0; height: 0; }

.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #e5e7eb;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px; width: 16px;
  left: 3px; bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider { background-color: #8b5cf6; }
input:checked + .slider:before { transform: translateX(18px); }

.slider.round { border-radius: 22px; }
.slider.round:before { border-radius: 50%; }

/* Modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4); /* Slate 900 translucent */
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  width: 500px;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: 1px solid #f1f5f9;
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8fafc;
}

.modal-header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.close-btn {
  font-size: 26px;
  color: #94a3b8;
  border: none;
  background: none;
  cursor: pointer;
  transition: color 0.15s;
}

.close-btn:hover {
  color: #475569;
}

/* Semester filter buttons */
.filter-btn { background-color: #e5e7eb; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 13px; display: flex; align-items: center; gap: 4px; color: #333; }
.filter-btn.active { background-color: #8b5cf6; color: white; }


.modal-body { padding: 24px; }

.form-group { margin-bottom: 18px; }
.form-group label { display: block; font-size: 13px; font-weight: 600; color: #475569; margin-bottom: 8px; }

.modal-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13.5px;
  color: #1e293b;
  background: white;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-footer {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}

.btn-save {
  background-color: #10b981;
  color: white;
  padding: 11px 24px;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.15);
  transition: all 0.2s;
}

.btn-save:hover:not(:disabled) {
  background-color: #059669;
  transform: translateY(-1px);
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.save-icon { font-size: 14px; }

/* Bottom Bar */
.bottom-bar {
  background: #fdfdfd;
  padding: 15px 20px;
  border-top: 1px solid #eee;
  font-size: 12px;
  color: #888;
}

/* Animations */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
